export default {
   /* eslint-disable key-spacing */
   '01': 'Aktif',
   '06': 'Dicabut',
   /* eslint-enable key-spacing */
}
